import React, { useCallback } from "react";
import { I18nextProvider, useTranslation } from "react-i18next";
import i18n, { setLocale } from "@/i18n";
import { api } from "@/lib/api";

export function I18nProvider({ children }) {
  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}

export function useI18n() {
  const { t, i18n: inst } = useTranslation();
  const locale = inst.language;
  const setLang = useCallback((l) => {
    setLocale(l);
    if (localStorage.getItem("tt_token")) api.patch("/users/me", { locale: l }).catch(() => {});
  }, []);
  return { t, locale, lang: locale.slice(0, 2), setLang };
}
